// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2930) return "static/chunks/2930-5751fc612ff930063e5c.js";
	if (chunkId === 8764) return "static/chunks/8764-4d9bf7c7511068439914.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"1167":"b22cc7acb6faa60dc930","2937":"81eb816279c55b32c3f0"}[chunkId] + ".js";
};